import React, { useEffect, useCallback, useState} from 'react';
import TrackEffects from "components/mix/mix2/TrackEffects.js";
import FilterSection from "components/instruments/FilterSection.js";
import EnvelopesComponent from "components/instruments/EnvelopesComponent.js";
import OperatorsMixer from "components/instruments/fm/OperatorsMixer.js";
import Colors from 'components/Colors.js';
import {ENVELOPE_OPTIONS} from 'components/instruments/constants.js';
import MiniOptions from './MiniOptions.js';
import {MULTI_SYNTH} from "constants/instrument-types.js";
import FMHarmonicityModulation from "components/instruments/FMHarmonicityModulation.js";
import {connect} from 'react-redux';
import '../../TrackMiniControl.scss';

window.miniTran = 0.5;
const colors = new Colors();

const TrackMiniControl = ({track, color}) => { 
    let [option, setOption] = useState(undefined);
    let [selectedOsc, setSelectedOsc] = useState(
        track.instrument && track.instrument.oscillatorNodes &&
            track.instrument.oscillatorNodes[0]);
    let type = track && track.instrument && track.instrument.getInstrumentType();

    let options = type === MULTI_SYNTH && !track.isFrozen ?  ["FM", "Mixer", "Env", "Filter", "FX"] : ["FX"];
    let backgroundColor = colors.transparent(color, window.miniTran);
    return (
        <div className="track-mini-control">
        {option === "FM" ? 
          <FMHarmonicityModulation
            color={color}
            height={100}
            backgroundColor={backgroundColor}
            innerHeight={96}
            instrument={track.instrument}
            sequencerEngine={track.sequencerEngine}
         oscillator={selectedOsc} setSelectedOsc={setSelectedOsc}/>
         : option === "Mixer" ?
         <OperatorsMixer
           color={color}
           setOscillatorDetails={setSelectedOsc}
           oscillatorDetails={selectedOsc}
           sequencerEngine={track.sequencerEngine}
           instrument={track.instrument}/>
         : option === 'Env' ?
         <EnvelopesComponent
           color={color}
           envelopeOptions={ENVELOPE_OPTIONS}
           sequencerEngine={track.sequencerEngine}
           instrument={track.instrument}/>
         : option === 'Filter' ?
         <FilterSection
           color={color}
           sequencerEngine={track.sequencerEngine}
           instrument={track.instrument}/>
         : option === "FX" ? 
         <TrackEffects showEffect={true} track={track}/> : '' 
        }
          <MiniOptions
            options={options}
            setOption={setOption}
            option={option}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackMiniControl);
